import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Accordion, AccordionItem, Collapse, Badge } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import CountUp from "react-countup";
import SimpleBar from "simplebar-react";
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import CurrencyInput from "react-currency-input-field";
import ModalImage from "react-modal-image";
import { api } from "../../../config";

// Formik
import { useSelector, useDispatch } from "react-redux";
import { resetCivilBudgetState, getCivilBudget } from "../../../store/civilBudget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetVendorState, getVendor } from "../../../store/vendor/action";
import { resetPurchaseState, getPurchase as onGetPurchases, resetPurchaseCreateState } from "../../../store/purchase/action";
import { resetCivilContractState, getCivilContract as onGetCivilContracts } from "../../../store/civilContract/action";
import { getAccReleaseTrans, getAccReleaseTransLoading } from "../../../store/accReleaseTrans/action";
import { addNewAccTrans as onAddNewAccTrans, getAccTrans, updateAccTrans as onUpdateAccTrans, getAccTransLoading } from "../../../store/accTrans/action";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Purchase = () => {
  const printRef = useRef(null);
  const expanseDataRef = useRef([]);
  const [pageIdx, setPageIdx] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeDetailTab, setActiveDetailTab] = useState("1");
  const [branchIdSelected, setBranchIdSelected] = useState(null);
  const [activeBlock, setActiveBlock] = useState("");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, purchases, loading, error, companies, vendors, vendorLoading, branches, branchLoading, civilContracts, civilContractLoading, civilBudgets, civilBudgetLoading, departments, departmentLoading, accTranss, accTransAdded, isAccTransCreated, isAccTransSuccess, accTransloading, accReleaseTranss, accReleaseTransLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    purchases: state.Purchase.purchases,
    loading: state.Purchase.loading,
    companies: state.Company.companies,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    vendors: state.Vendor.vendors,
    vendorLoading: state.Vendor.loading,
    error: state.Purchase.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    civilContracts: state.CivilContract.civilContracts,
    civilContractLoading: state.CivilContract.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    accTranss: state.AccTrans.accTranss,
    accTransAdded: state.AccTrans.accTransAdded,
    isAccTransCreated: state.AccTrans.isAccTransCreated,
    isAccTransSuccess: state.AccTrans.isAccTransSuccess,
    accTransloading: state.AccTrans.loading,
    accReleaseTranss: state.AccReleaseTrans.accReleaseTranss,
    accReleaseTransLoading: state.AccReleaseTrans.loading,
  }));

  const [purchaseList, setPurchaseList] = useState([]);
  const [summaryList, setSummaryList] = useState([]);
  const [printDoc, setPrintDoc] = useState([]);
  const [info, setInfo] = useState([]);
  const [expense, setExpense] = useState([]);
  const [label, setLabel] = useState([]);
  const [active, setActive] = useState("TERMIN");
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusPurchase, setStatusPurchase] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchBudget, setSearchBudget] = useState(null);
  const [searchVendor, setSearchVendor] = useState(null);
  const [searchDepartment, setSearchDepartment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetTypeList, setCivilBudgetTypeList] = useState([]);

  const [printMaterialDoc, setPrintMaterialDoc] = useState([]);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState("");
  const [logList, setLogList] = useState([]);
  const [query, setQuery] = useState("");

  const [payable, setPayable] = useState(0);
  const [payable30, setPayable30] = useState(0);
  const [payable60, setPayable60] = useState(0);
  const [payable90, setPayable90] = useState(0);
  const [payable135, setPayable135] = useState(0);
  const [payable150, setPayable150] = useState(0);

  const [payWkTotal, setPayWkTotal] = useState(0);
  const [payWk1, setPayWk1] = useState(0);
  const [payWk2, setPayWk2] = useState(0);
  const [payWk3, setPayWk3] = useState(0);
  const [payWk4, setPayWk4] = useState(0);
  const [payWk5, setPayWk5] = useState(0);
  const [payWk6, setPayWk6] = useState(0);
  const [payWk7, setPayWk7] = useState(0);
  const [payWk8, setPayWk8] = useState(0);
  const [payWk9, setPayWk9] = useState(0);
  const [payWk10, setPayWk10] = useState(0);
  const [payWk11, setPayWk11] = useState(0);
  const [payWk12, setPayWk12] = useState(0);
  const [payWk13, setPayWk13] = useState(0);
  const [payWk14, setPayWk14] = useState(0);
  const [payWk15, setPayWk15] = useState(0);

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const scrollRef = useRef(null);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  const handleMouseDown = (e) => {
    setIsDown(true);

    const rect = scrollRef.current.getBoundingClientRect();

    setStartX(e.clientX - rect.left);
    setStartY(e.clientY - rect.top);

    setScrollLeft(scrollRef.current.scrollLeft);
    setScrollTop(scrollRef.current.scrollTop);
  };

  const handleMouseLeave = () => {
    setIsDown(false);
  };

  const handleMouseUp = () => {
    setIsDown(false);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;

    e.preventDefault();

    const rect = scrollRef.current.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const walkX = (x - startX) * 1.5; // speed horizontal
    const walkY = (y - startY) * 1.5; // speed vertical

    scrollRef.current.scrollLeft = scrollLeft - walkX;
    scrollRef.current.scrollTop = scrollTop - walkY;
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "supplier",
        label: "Kontak / Supplier",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_reff",
        label: "No Invoice",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "dueat",
        label: "Jatuh Tempo",
        isSelected: true,
        data: [],
      },
      {
        id: "total_winv",
        label: "Menunggu Inv",
        isSelected: true,
        data: [],
      },
      {
        id: "total_inv",
        label: "Naik Inv",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "paid_amount",
        label: "Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "left_amount",
        label: "Menunggu Bayar",
        isSelected: true,
        data: [],
      },
      {
        id: "expired",
        label: "Jatuh Tempo",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {

          let doc = dataDoc.find((d) => d.id === "supplier");
          doc.data.push(label);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transaction_reff");
          doc.data.push(data?.transaction_reff);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "dueat");
          doc.data.push(data?.dueat ? handleValidDate(data?.dueat) : handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "total_inv");
          doc.data.push(data?.transaction_no ? data?.total_amount : "");

          doc = dataDoc.find((d) => d.id === "total_winv");
          doc.data.push(data?.transaction_no ? "" : data?.total_amount);

          doc = dataDoc.find((d) => d.id === "total_amount");
          doc.data.push(data?.total_amount);

          doc = dataDoc.find((d) => d.id === "paid_amount");
          doc.data.push(data?.paid_amount);

          doc = dataDoc.find((d) => d.id === "left_amount");
          doc.data.push(data?.total);

          doc = dataDoc.find((d) => d.id === "expired");
          doc.data.push(data?.range0);

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }


    setPrintMaterialDoc(dataDoc);
  }, [expense]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tag",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "tag");
          doc.data.push(data?.at_cvl_account?.name || data?.at_legal?.owner || data?.at_cvl_contract?.cvl_contract_cvl_account?.name || (data?.at_purchase?.purchase_detail[0] && data?.at_purchase?.purchase_detail[0]?.cvl_account) || data?.at_tag?.name);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "amount");
          doc.data.push(Math.round(data?.amount));

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  useEffect(() => {
    if (active === "TERMIN") {
      let dataDoc = [
        {
          id: "supplier",
          label: "Kontak / Supplier",
          isSelected: true,
          data: [],
        },
        {
          id: "type",
          label: "Jenis Hutang",
          isSelected: true,
          data: [],
        },
        {
          id: "invoice_non_amount",
          label: "Menunggu Inv",
          isSelected: true,
          data: [],
        },
        {
          id: "invoice_amount",
          label: "Naik Inv",
          isSelected: true,
          data: [],
        },
        {
          id: "total_amount",
          label: "Total Hutang",
          isSelected: true,
          data: [],
        },
        {
          id: "paid_amount",
          label: "Terbayar",
          isSelected: true,
          data: [],
        },
        {
          id: "total",
          label: "Sisa Hutang",
          isSelected: true,
          data: [],
        },
        {
          id: "range0",
          label: "Jatuh Tempo",
          isSelected: true,
          data: [],
        },
        {
          id: "range1",
          label: "1-30 Hari",
          isSelected: true,
          data: [],
        },
        {
          id: "range2",
          label: "30-60 Hari",
          isSelected: true,
          data: [],
        },
        {
          id: "range3",
          label: "60-90 Hari",
          isSelected: true,
          data: [],
        },
        {
          id: "range4",
          label: "90-135 Hari",
          isSelected: true,
          data: [],
        },
        {
          id: "range5",
          label: "> 135 Hari",
          isSelected: true,
          data: [],
        },
      ];

      if (purchaseList.length > 0) {
        purchaseList.forEach((purchase) => {
          if (purchase.isChecked) {
            Object.entries(purchase).forEach(([key, value]) => {
              const doc = dataDoc.find((d) => d.id === key);
              if (doc) {
                if (doc.id === "range1" || doc.id === "range2" || doc.id === "range3" || doc.id === "range4" || doc.id === "range5") {
                  doc.data.push(currencyFormat(value === null ? 0 : value));
                } else {
                  doc.data.push(value);
                }
              }
            });
          }
        });
      }
      setPrintDoc(dataDoc);
    } else {
      let dataDoc = [
        {
          id: "supplier",
          label: "Kontak / Supplier",
          isSelected: true,
          data: [],
        },
        {
          id: "type",
          label: "Jenis Hutang",
          isSelected: true,
          data: [],
        },
        {
          id: "total_amount",
          label: "Total Hutang",
          isSelected: true,
          data: [],
        },
        {
          id: "paid_amount",
          label: "Terbayar",
          isSelected: true,
          data: [],
        },
        {
          id: "total",
          label: "Sisa Hutang",
          isSelected: true,
          data: [],
        },
        {
          id: "range0",
          label: "Jatuh Tempo",
          isSelected: true,
          data: [],
        },
        {
          id: "range1",
          label: "M-" + Math.ceil(moment.utc().local().date() / 7) + " " + moment.utc().local().format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range2",
          label: "M-" + Math.ceil(moment.utc().local().add(1, "weeks").date() / 7) + " " + moment.utc().local().add(1, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range3",
          label: "M-" + Math.ceil(moment.utc().local().add(2, "weeks").date() / 7) + " " + moment.utc().local().add(2, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range4",
          label: "M-" + Math.ceil(moment.utc().local().add(3, "weeks").date() / 7) + " " + moment.utc().local().add(3, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range5",
          label: "M-" + Math.ceil(moment.utc().local().add(4, "weeks").date() / 7) + " " + moment.utc().local().add(4, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range6",
          label: "M-" + Math.ceil(moment.utc().local().add(5, "weeks").date() / 7) + " " + moment.utc().local().add(5, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range7",
          label: "M-" + Math.ceil(moment.utc().local().add(6, "weeks").date() / 7) + " " + moment.utc().local().add(6, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range8",
          label: "M-" + Math.ceil(moment.utc().local().add(7, "weeks").date() / 7) + " " + moment.utc().local().add(7, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range9",
          label: "M-" + Math.ceil(moment.utc().local().add(8, "weeks").date() / 7) + " " + moment.utc().local().add(8, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range10",
          label: "M-" + Math.ceil(moment.utc().local().add(9, "weeks").date() / 7) + " " + moment.utc().local().add(9, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range11",
          label: "M-" + Math.ceil(moment.utc().local().add(10, "weeks").date() / 7) + " " + moment.utc().local().add(10, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range12",
          label: "M-" + Math.ceil(moment.utc().local().add(11, "weeks").date() / 7) + " " + moment.utc().local().add(11, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range13",
          label: "M-" + Math.ceil(moment.utc().local().add(12, "weeks").date() / 7) + " " + moment.utc().local().add(12, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range14",
          label: "M-" + Math.ceil(moment.utc().local().add(13, "weeks").date() / 7) + " " + moment.utc().local().add(13, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
        {
          id: "range15",
          label: "M-" + Math.ceil(moment.utc().local().add(14, "weeks").date() / 7) + " " + moment.utc().local().add(14, "weeks").format("MMM YYYY"),
          isSelected: true,
          data: [],
        },
      ];

      if (purchaseList.length > 0) {
        purchaseList.forEach((purchase) => {
          if (purchase.isChecked) {
            Object.entries(purchase).forEach(([key, value]) => {
              const doc = dataDoc.find((d) => d.id === key);
              if (doc) {
                if (doc.id === "range1" || doc.id === "range2" || doc.id === "range3" || doc.id === "range4" || doc.id === "range5") {
                  doc.data.push(currencyFormat(value === null ? 0 : value));
                } else {
                  doc.data.push(value);
                }
              }
            });
          }
        });
      }
      setPrintDoc(dataDoc);
    }
  }, [purchaseList, active]);

  const handleGetPayable = (id, branchId) => {
    setPurchaseList([]);
    dispatch(resetCivilContractState());
    dispatch(resetPurchaseState());
    dispatch(onGetCivilContracts({ companyId: id, branchId: branchId, date: "all" }));
    dispatch(onGetPurchases({ companyId: id, branchId: branchId, typeId: 1, date: "all" }));
    dispatch(getAccTrans({ payable: true, companyId: id, branchId: branchId, date: "all" }));
    dispatch(getAccReleaseTrans({ companyId: id, branchId: branchId }));
    setBranchIdSelected(branchId);
    handleGetCivilBudget(id, branchId);
    handleGetDepartement(id);
    handleGetVendor(id);
  };

  const handleGetVendor = (companyId) => {
    dispatch(resetVendorState());
    dispatch(getVendor());
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [{ label: "SEMUA DEPT.", value: "" }];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      var civilBudgetData = [];
      var civilTypeData = [{ label: "SEMUA ANGGARAN", value: "all" }, { label: "NON RAB", value: "none" }];
      var opt = [];
      var optType = [];
      civilBudgets
        .filter((f) => f.type === "BANGUNAN" || f.type === "INFRASTRUKTUR" || f.type === "PEKERJAAN TAMBAH 1" || f.type === "PEKERJAAN TAMBAH 2" || f.type === "PEKERJAAN TAMBAH 3" || f.type === "PEKERJAAN TAMBAH 4" || f.type === "PEKERJAAN TAMBAH 5" || f.type === "PEKERJAAN TAMBAH 6" || f.type === "PEKERJAAN TAMBAH 7" || f.type === "PEKERJAAN TAMBAH 8" || f.type === "LISTRIK JARINGAN")
        .forEach((it, idx) => {
          const type = it.type ? it.type : "";
          const typeName = it.name ? it.name : "";
          if (branchIdSelected === it.branchId) {
            const budgetId = it.id ? it.id : "";
            it.cvl_detail.forEach((item, key) => {
              const name = item?.cvld_account?.name;
              const id = item?.cvld_account?.id;
              opt.push({ label: type + " - " + name, cvl_account: name, value: budgetId, type: type, civilBudgetId: budgetId, civilBudgetDetailId: item.id, civilAccountId: id, material: item.cvld_material });
            });
          }
          optType.push({ label: typeName, value: it.id });
        });
      var option = { options: opt };
      var option_type = { options: optType };
      civilBudgetData.push(option);
      civilTypeData.push(option_type);
      setCivilBudgetList(civilBudgetData);
      setCivilBudgetTypeList(civilTypeData);
    } else {
      setCivilBudgetTypeList([]);
      setCivilBudgetList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  const toggleDetailTab = (tab) => {
    if (activeDetailTab !== tab) {
      setActiveDetailTab(tab);
    }
  };

  const parseNumber = (val) => {
    if (typeof val === 'number') return val;
    if (!val) return 0;
    // Menghapus karakter non-digit kecuali titik desimal (jika ada format ribuan dengan titik/koma)
    const cleaned = String(val).replace(/[^0-9.-]/g, '');
    return parseFloat(cleaned) || 0;
  };

  const toggleTab = useCallback(
    (tab, type, filterValue, vendorValue, deptValue) => {
      setActive(type);
      setActiveTab(tab);

      // 1. Filtering Awal Data
      let filteredPurchases = [...purchases];
      let filteredCivilContracts = [...civilContracts];
      let filteredAccTrans = [...accTranss];
      const arrLog = [];

      // Filter Budget
      if (filterValue && filterValue !== "all") {
        if (filterValue === "none") {
          filteredPurchases = filteredPurchases.filter((el) =>
            el.purchase_detail?.some((dtl) => !dtl?.civilBudgetId)
          );
          filteredCivilContracts = filteredCivilContracts.filter((el) => !el.civilBudgetId);
          filteredAccTrans = filteredAccTrans.filter((el) => !el.civilBudgetId);
        } else {
          filteredPurchases = filteredPurchases.filter((el) =>
            el.purchase_detail?.some((dtl) => dtl?.civilBudgetId === filterValue)
          );
          filteredCivilContracts = filteredCivilContracts.filter((el) => el.civilBudgetId === filterValue);
          filteredAccTrans = filteredAccTrans.filter((el) => el.civilBudgetId === filterValue);
        }
      }

      // Filter Vendor
      if (vendorValue) {
        filteredPurchases = filteredPurchases.filter((el) => el?.purchase_vendor?.name === vendorValue);
        filteredCivilContracts = filteredCivilContracts.filter((el) => el?.cvl_contract_vendor?.name === vendorValue);
        filteredAccTrans = filteredAccTrans.filter((el) => el?.at_user?.name === vendorValue);
      }

      // Filter Department
      if (deptValue) {
        filteredPurchases = filteredPurchases.filter((el) => el?.departmentId === deptValue);
        filteredCivilContracts = filteredCivilContracts.filter((el) => el?.departmentId === deptValue);
        filteredAccTrans = filteredAccTrans.filter((el) => el?.departmentId === deptValue);
      }

      // Pre-indexing accReleaseTranss ke Map O(1)
      const releaseByPurchase = new Map();
      const releaseByContract = new Map();
      const releaseByAccTrx = new Map();

      (accReleaseTranss || []).forEach((rel) => {
        if (rel.purchaseId) {
          if (!releaseByPurchase.has(rel.purchaseId)) releaseByPurchase.set(rel.purchaseId, []);
          releaseByPurchase.get(rel.purchaseId).push(rel);
        }
        if (rel.civilContractId) {
          if (!releaseByContract.has(rel.civilContractId)) releaseByContract.set(rel.civilContractId, []);
          releaseByContract.get(rel.civilContractId).push(rel);
        }
        if (rel.accTrxId) {
          if (!releaseByAccTrx.has(rel.accTrxId)) releaseByAccTrx.set(rel.accTrxId, []);
          releaseByAccTrx.get(rel.accTrxId).push(rel);
        }
      });

      const today = moment.utc().startOf("day");

      // ---------------------------------------------------------------------
      // MODE 1: TERMIN (AGED PAYABLES SUMMARY)
      // ---------------------------------------------------------------------
      if (type === "TERMIN") {
        const supplierMap = new Map();
        let pay = 0, pay30 = 0, pay60 = 0, pay90 = 0, pay135 = 0, pay150 = 0;

        const accumulateTerminBucket = (target, diff, amount) => {
          if (diff > 0) target.range0 += amount;
          if (diff >= 0 && diff < 30) target.range1 += amount;
          if (diff >= 30 && diff < 60) target.range2 += amount;
          if (diff >= 60 && diff < 90) target.range3 += amount;
          if (diff >= 90 && diff < 135) target.range4 += amount;
          if (diff >= 135) target.range5 += amount;
        };

        const upsertTerminSupplier = ({ key, type: itemType, branch, supplierName, invoiceAmt, nonInvoiceAmt, totalAmt, paidAmt, total, diff, realTrans, detailItem }) => {
          if (supplierMap.has(key)) {
            const item = supplierMap.get(key);
            item.total += total;
            item.total_amount += totalAmt;
            item.paid_amount += paidAmt;
            item.invoice_amount += invoiceAmt;
            item.invoice_non_amount += nonInvoiceAmt;
            item.realization.push(...realTrans);
            accumulateTerminBucket(item, diff, total);
            if (detailItem) item.detail.push(detailItem);
          } else {
            const newItem = {
              id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
              type: itemType,
              branch,
              supplier: supplierName,
              invoice_amount: invoiceAmt,
              invoice_non_amount: nonInvoiceAmt,
              total_amount: totalAmt,
              paid_amount: paidAmt,
              total,
              realization: [...realTrans],
              range0: 0, range1: 0, range2: 0, range3: 0, range4: 0, range5: 0,
              detail: detailItem ? [detailItem] : [],
            };
            accumulateTerminBucket(newItem, diff, total);
            supplierMap.set(key, newItem);
          }
        };

        // --- Purchases ---
        for (const data of filteredPurchases) {
          if (![2, 3, 4, 5].includes(data.statusId)) continue;
          const supplierName = data?.purchase_vendor?.name || "UNKNOWN";
          const apply = releaseByPurchase.get(data.id) || [];
          const cvlAccountName = data?.purchase_detail?.[0]?.cvl_account;

          const trans = (data.purchase_trans || []).map((tr) => {
            const copyTr = { ...tr, at_cvl_account: { name: cvlAccountName } };
            if (copyTr.type === "PAYABLE") arrLog.push(copyTr.id);
            return copyTr;
          });

          const existingTransIds = new Set(trans.map((t) => t.id));
          for (const release of data.purchase_trans_release || []) {
            if (!release?.at_rls_trans) continue;
            const releaseTrans = { ...release.at_rls_trans, amount: release.amount, at_cvl_account: { name: cvlAccountName } };
            if (release.purchaseId === data.id && !existingTransIds.has(releaseTrans.id)) {
              trans.push(releaseTrans);
              existingTransIds.add(releaseTrans.id);
            }
          }

          const dueatDate = moment.utc(data.dueat, "YYYY/MM/DD HH:mm:ss").startOf("day");
          const diff = today.diff(dueatDate, "days");

          const total_amount = parseNumber(data.total_amount);
          const paid_amount = parseNumber(data.paid_amount);
          const total = total_amount - paid_amount;
          const total_invoice = [4, 5].includes(data.statusId) ? total_amount : 0;
          const total_non_invoice = [2, 3].includes(data.statusId) ? total_amount : 0;

          const appliedTotal = apply.filter((f) => f?.at_rls_trans?.statusId !== 4).reduce((acc, v) => acc + parseNumber(v.amount), 0);
          const total_apply = total_amount - appliedTotal;

          pay += total;
          if (diff >= 0 && diff < 30) pay30 += total;
          else if (diff >= 30 && diff < 60) pay60 += total;
          else if (diff >= 60 && diff < 90) pay90 += total;
          else if (diff >= 90 && diff < 135) pay135 += total;
          else if (diff >= 135) pay150 += total;

          const detailItem = {
            id: data?.id,
            departmentId: data?.departmentId,
            rab: data?.purchase_detail?.[0]?.purchase_cvl_budget?.type,
            civilContractId: null,
            purchaseId: data?.id,
            vendorId: data?.vendorId,
            type: "Material",
            branch: data?.purchase_branch?.branch_code,
            transaction_no: data?.transaction_no,
            transactionat: data?.transactionat,
            dueat: data?.dueat,
            transaction_reff: data?.transaction_reff,
            description: data?.description,
            supplier: supplierName,
            purchase_detail: data?.purchase_detail,
            file: data?.purchase_file,
            total,
            amount: total_amount,
            total_amount,
            paid_amount,
            paid_apply: 0,
            total_apply,
            apply,
          };

          upsertTerminSupplier({
            key: `${supplierName}_Material`,
            type: "Material",
            branch: data?.purchase_branch?.branch_code,
            supplierName,
            invoiceAmt: total_invoice,
            nonInvoiceAmt: total_non_invoice,
            totalAmt: total_amount,
            paidAmt: paid_amount,
            total,
            diff,
            realTrans: trans.filter((f) => f.statusId === 3),
            detailItem,
          });
        }

        // --- Civil Contracts ---
        for (const data of filteredCivilContracts.filter((f) => [1, 2].includes(f.statusId))) {
          const supplierName = data?.cvl_contract_vendor?.name || "UNKNOWN";
          const apply = releaseByContract.get(data.id) || [];
          const cvlAccountName = data?.cvl_contract_cvl_account?.name;

          const trans = (data.cvl_contract_trans || []).map((tr) => {
            const copyTr = { ...tr, at_cvl_account: { name: cvlAccountName } };
            if (copyTr.type === "PAYABLE") arrLog.push(copyTr.id);
            return copyTr;
          });

          const existingTransIds = new Set(trans.map((t) => t.id));
          for (const release of data.contract_trans_release || []) {
            if (!release?.at_rls_trans) continue;
            const releaseTrans = { ...release.at_rls_trans, amount: release.amount, at_cvl_account: { name: cvlAccountName } };
            if (release.civilContractId === data.id && !existingTransIds.has(releaseTrans.id)) {
              trans.push(releaseTrans);
              existingTransIds.add(releaseTrans.id);
            }
          }

          const startDate = moment.utc(data.startat, "YYYY/MM/DD HH:mm:ss").startOf("day");
          const diff = today.diff(startDate, "days");

          const total_amount = parseNumber(data.payable_amount);
          const paid_amount = parseNumber(data.paid_amount);
          const total = total_amount - paid_amount;
          const total_invoice = total_amount;
          const total_non_invoice = parseNumber(data.amount) - total_amount;

          const appliedTotal = apply.filter((f) => f?.at_rls_trans?.statusId !== 4).reduce((acc, v) => acc + parseNumber(v.amount), 0);
          const total_apply = total_amount - appliedTotal;

          pay += total;
          if (diff >= 0 && diff < 30) pay30 += total;
          else if (diff >= 30 && diff < 60) pay60 += total;
          else if (diff >= 60 && diff < 90) pay90 += total;
          else if (diff >= 90 && diff < 135) pay135 += total;
          else if (diff >= 135) pay150 += total;

          const detailItem = {
            id: data?.id,
            departmentId: data?.departmentId,
            rab: data?.cvl_contract_cvl_budget?.type,
            civilContractId: data?.id,
            purchaseId: null,
            vendorId: data?.vendorId,
            type: "SPK",
            branch: data?.cvl_contract_branch?.branch_code,
            transaction_no: data?.transaction_no,
            transactionat: data?.transactionat,
            dueat: data?.dueat,
            transaction_reff: data?.transaction_reff,
            description: data?.description,
            supplier: supplierName,
            total,
            amount: parseNumber(data.amount),
            total_amount: total_invoice,
            paid_amount,
            paid_apply: 0,
            total_apply,
            apply,
          };

          upsertTerminSupplier({
            key: `${supplierName}_SPK`,
            type: "SPK",
            branch: data?.cvl_contract_branch?.branch_code,
            supplierName,
            invoiceAmt: total_invoice,
            nonInvoiceAmt: total_non_invoice,
            totalAmt: total_amount,
            paidAmt: paid_amount,
            total,
            diff,
            realTrans: trans.filter((f) => f.statusId === 3),
            detailItem,
          });
        }

        // --- Acc Trans ---
        for (const data of filteredAccTrans.filter((f) => f.statusId === 3)) {
          const supplierName = data?.at_user?.name ?? "NO NAME";
          const apply = releaseByAccTrx.get(data.id) || [];
          const cvlAccountName = data?.at_cvl_account?.name;

          const txDate = moment.utc(data.transactionat, "YYYY/MM/DD HH:mm:ss").startOf("day");
          const diff = today.diff(txDate, "days");

          const total_amount = parseNumber(data.amount);
          const paid_amount = parseNumber(data.paid_amount);
          const total = total_amount - paid_amount;

          const appliedTotal = apply.filter((f) => f?.at_rls_trans?.statusId !== 4).reduce((acc, v) => acc + parseNumber(v.amount), 0);
          const total_apply = total_amount - appliedTotal;

          pay += total;
          if (diff >= 0 && diff < 30) pay30 += total;
          else if (diff >= 30 && diff < 60) pay60 += total;
          else if (diff >= 60 && diff < 90) pay90 += total;
          else if (diff >= 90 && diff < 135) pay135 += total;
          else if (diff >= 135) pay150 += total;

          const trans = [{ ...data, at_cvl_account: { name: cvlAccountName } }];
          if (data.type === "PAYABLE") arrLog.push(data.id);

          const existingTransIds = new Set(trans.map((t) => t.id));
          for (const release of apply) {
            if (!release?.at_rls_trans) continue;
            const releaseTrans = { ...release.at_rls_trans, amount: release.amount, at_cvl_account: { name: cvlAccountName } };
            if (release.accTrxId === data.id && !existingTransIds.has(releaseTrans.id)) {
              trans.push(releaseTrans);
              existingTransIds.add(releaseTrans.id);
            }
          }

          const detailItem = data.type === "PAYABLE" ? {
            id: data?.id,
            departmentId: data?.departmentId,
            rab: data.civilBudgetId ? data?.at_budget?.type : "",
            type: "Keuangan",
            branch: data?.at_branch?.branch_code,
            civilContractId: null,
            purchaseId: null,
            userId: data?.at_user?.id || null,
            vendorId: null,
            transaction_no: data?.transaction_no,
            transactionat: data?.transactionat,
            dueat: data?.transactionat,
            transaction_reff: data?.transaction_reff,
            description: data?.description,
            supplier: supplierName,
            file: data?.at_file,
            total,
            amount: total_amount,
            total_amount,
            paid_amount,
            paid_apply: 0,
            total_apply,
            apply,
          } : null;

          if (data.type === "PAYABLE" || supplierMap.has(`${supplierName}_Keuangan`)) {
            upsertTerminSupplier({
              key: `${supplierName}_Keuangan`,
              type: "Keuangan",
              branch: data?.at_branch?.branch_code,
              supplierName,
              invoiceAmt: total_amount,
              nonInvoiceAmt: 0,
              totalAmt: total_amount,
              paidAmt: paid_amount,
              total,
              diff,
              realTrans: trans.filter((f) => f.statusId === 3),
              detailItem,
            });
          }
        }

        const arrResult = Array.from(supplierMap.values());
        setLogList(arrLog);
        setPayable(pay);
        setPayable30(pay30);
        setPayable60(pay60);
        setPayable90(pay90);
        setPayable135(pay135);
        setPayable150(pay150);
        setPurchaseList(arrResult.map((el) => ({ ...el, isChecked: false })));
        setInfo(arrResult[arrResult.length - 1] || null);

      // ---------------------------------------------------------------------
      // MODE 2: MINGGUAN (WEEKLY AGING FORECAST)
      // ---------------------------------------------------------------------
      } else if (type === "MINGGUAN") {
        const supplierMap = new Map();
        const weeklyTotals = Array(16).fill(0);
        const w1 = moment.utc().local().isoWeek();

        const accumulateWeeklyRanges = (target, currentWeek, total) => {
          if (currentWeek <= w1) target.range1 += total;
          else if (currentWeek >= w1 + 14) target.range15 += total;
          else {
            const index = currentWeek - w1 + 1;
            target[`range${index}`] += total;
          }
        };

        const upsertWeeklySupplier = ({ key, type: itemType, branch, supplierName, invoiceAmt, nonInvoiceAmt, totalAmt, paidAmt, total, currentWeek, realTrans, detailItem }) => {
          if (supplierMap.has(key)) {
            const item = supplierMap.get(key);
            item.total += total;
            item.total_amount += totalAmt;
            item.paid_amount += paidAmt;
            item.invoice_amount += invoiceAmt;
            item.invoice_non_amount += nonInvoiceAmt;
            item.realization.push(...realTrans);
            accumulateWeeklyRanges(item, currentWeek, total);
            if (detailItem) item.detail.push(detailItem);
          } else {
            const newItem = {
              id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
              type: itemType,
              branch,
              supplier: supplierName,
              invoice_amount: invoiceAmt,
              invoice_non_amount: nonInvoiceAmt,
              total_amount: totalAmt,
              paid_amount: paidAmt,
              total,
              realization: [...realTrans],
              range1: 0, range2: 0, range3: 0, range4: 0, range5: 0, range6: 0, range7: 0,
              range8: 0, range9: 0, range10: 0, range11: 0, range12: 0, range13: 0, range14: 0, range15: 0,
              detail: detailItem ? [detailItem] : [],
            };
            accumulateWeeklyRanges(newItem, currentWeek, total);
            supplierMap.set(key, newItem);
          }
        };

        for (const data of filteredPurchases) {
          if (![2, 3, 4, 5].includes(data.statusId)) continue;
          const supplierName = data?.purchase_vendor?.name || "UNKNOWN";
          const current = moment.utc(data.dueat).local().isoWeek();
          const total_amount = parseNumber(data.total_amount);
          const paid_amount = parseNumber(data.paid_amount);
          const total = total_amount - paid_amount;
          const total_invoice = [4, 5].includes(data.statusId) ? total_amount : 0;
          const total_non_invoice = [2, 3].includes(data.statusId) ? total_amount : 0;

          if (current <= w1) weeklyTotals[1] += total;
          else if (current >= w1 + 14) weeklyTotals[15] += total;
          else weeklyTotals[current - w1 + 1] += total;

          upsertWeeklySupplier({
            key: `${supplierName}_Material`,
            type: "Material",
            branch: data?.purchase_branch?.branch_code,
            supplierName,
            invoiceAmt: total_invoice,
            nonInvoiceAmt: total_non_invoice,
            totalAmt: total_amount,
            paidAmt: paid_amount,
            total,
            currentWeek: current,
            realTrans: [],
            detailItem: null,
          });
        }


        const arrResult = Array.from(supplierMap.values());
        setPurchaseList(arrResult.map((el) => ({ ...el, isChecked: false })));
        setInfo(arrResult[arrResult.length - 1] || null);

      // ---------------------------------------------------------------------
      // MODE 3: SUMMARY (SUMMARY BY ACCOUNT/RAB)
      // ---------------------------------------------------------------------
      } else {
        const summaryMap = new Map();

        for (const data of filteredPurchases) {
          if (![2, 3, 4, 5].includes(data.statusId)) continue;
          const supplierName = data?.purchase_vendor?.name || "UNKNOWN";
          const total_amount = parseNumber(data.total_amount);
          const paid_amount = parseNumber(data.paid_amount);
          const total = total_amount - paid_amount;
          const total_invoice = [4, 5].includes(data.statusId) ? total_amount : 0;
          const total_non_invoice = [2, 3].includes(data.statusId) ? total_amount : 0;

          let paidForPD = paid_amount;
          let supplier = summaryMap.get(supplierName);

          if (!supplier) {
            supplier = {
              id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
              branch: data?.purchase_branch?.branch_code,
              supplier: supplierName,
              invoice_amount: 0,
              invoice_non_amount: 0,
              total_amount: 0,
              paid_amount: 0,
              total: 0,
              detail: [],
            };
            summaryMap.set(supplierName, supplier);
          }

          supplier.total += total;
          supplier.total_amount += total_amount;
          supplier.paid_amount += paid_amount;
          supplier.invoice_amount += total_invoice;
          supplier.invoice_non_amount += total_non_invoice;

          for (const pd of data.purchase_detail || []) {
            const rabName = pd?.purchase_cvl?.name || "N/A";
            let findAccount = supplier.detail.find((d) => d.rab === rabName);
            if (!findAccount) {
              findAccount = { rab: rabName, data: [] };
              supplier.detail.push(findAccount);
            }

            const pdAmountTotal = parseNumber(pd.amount_total);
            const pdQuantity = parseNumber(pd.quantity);
            const paidAllocation = paidForPD >= pdAmountTotal ? pdAmountTotal : paidForPD;

            let findPD = findAccount.data.find(
              (d) => d.productId === pd.productId && d.civilBudgetId === pd.civilBudgetId
            );

            if (findPD) {
              findPD.amount_total += pdAmountTotal;
              findPD.quantity += pdQuantity;
              findPD.paid += paidAllocation;
            } else {
              findAccount.data.push({
                ...pd,
                amount_total: pdAmountTotal,
                quantity: pdQuantity,
                paid: paidAllocation,
              });
            }
            paidForPD = paidForPD >= pdAmountTotal ? paidForPD - pdAmountTotal : 0;
          }
        }

        const arrSummary = Array.from(summaryMap.values());
        setSummaryList(arrSummary.map((el) => ({ ...el, isChecked: false })));
      }
    },
    [purchases, civilContracts, accTranss, accReleaseTranss]
  );

  // =========================================================================
  // USEEFFECT UNTUK TRIGGER OTOMATIS SAAT DEPENDENSI BERUBAH
  // =========================================================================
  useEffect(() => {
    toggleTab(
      activeTab,
      active,
      searchBudget?.value,
      null,
      searchDepartment?.value
    );
  }, [
    activeTab,
    active,
    searchBudget,
    searchDepartment,
    purchases,
    civilContracts,
    accTranss,
    accReleaseTranss,
    toggleTab,
  ]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => { }, []);

  const handleBeforePrint = useCallback(() => { }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion("");
  };

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      var vendorData = [];
      var opt = [];
      vendors.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      vendorData.push(option);
      setVendorList(vendorData);
    }
  }, [vendors]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setQuery("");
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = purchaseList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPurchaseList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = purchaseList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setPurchaseList(updatedData);
                }}
              />
            </div>
          );
        },
      },
      {
        Header: "Kontak / Supplier",
        accessor: "supplier",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-primary fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.detail;
                setLabel(data.supplier);
                setExpense(data.detail);
                setModalDetail(true);
              }}>
              {data.supplier}
            </div>
          );
        },
      },
      {
        Header: "Jenis",
        accessor: "type",
        filterable: true,
      },
      {
        id: "MenungguInv",
        Header: <div className="pe-3">Menunggu Inv</div>,
        accessor: "invoice_non_amount",
        filterable: true,
        Cell: (data) => {
          return <span className="fw-semibold">{data.value ? currencyFormat(data.value) : 0}</span>;
        },
      },
      {
        Header: "Naik Inv",
        accessor: "invoice_amount",
        filterable: true,
        Cell: (data) => {
          return <span className="fw-semibold">{data.value ? currencyFormat(data.value) : 0}</span>;
        },
      },
      {
        Header: "Total",
        accessor: "total_amount",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-primary fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.detail;
                setLabel(data.supplier);
                setExpense(data.detail);
                setModalDetail(true);
              }}
            >
              {currencyFormat(data.total_amount === null ? 0 : data.total_amount)}
            </div>
          );
        },
      },
      {
        Header: "Terbayar",
        accessor: "paid_amount",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(data.paid_amount === null ? 0 : data.paid_amount)}
            </div>
          );
        },
      },
      {
        Header: "Sisa Hutang",
        accessor: "total",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-warning fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(data.total === null ? 0 : data.total)}
            </div>
          );
        },
      },
      ...(active === "TERMIN"
        ? [
          {
            Header: "Jatuh Tempo",
            accessor: "range0",
            filterable: true,
            Cell: (cellProps) => {
              const data = cellProps.row.original;
              return (
                <div
                  className="cursor-pointer text-danger fw-semibold"
                  onClick={() => {
                    expanseDataRef.current = data.realization;
                    setInfo(data);
                    setExpense(data.realization || []);
                    toggle();
                  }}
                >
                  {currencyFormat(data.range0 === null ? 0 : data.range0)}
                </div>
              );
            },
          },
          {
            id: "1-30-Hari",
            Header: "1-30 Hari",
            accessor: "range1",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.row.original.range1 === null ? 0 : data.row.original.range1)}</span>;
            },
          },
          {
            id: "30-60-Hari",
            Header: "30-60 Hari",
            accessor: "range2",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.row.original.range2 === null ? 0 : data.row.original.range2)}</span>;
            },
          },
          {
            id: "60-90-Hari",
            Header: "60-90 Hari",
            accessor: "range3",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.row.original.range3 === null ? 0 : data.row.original.range3)}</span>;
            },
          },
          {
            id: "90-135-Hari",
            Header: "90-135 Hari",
            accessor: "range4",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.row.original.range4 === null ? 0 : data.row.original.range4)}</span>;
            },
          },
          {
            id: "135-Hari",
            Header: "> 135 Hari",
            accessor: "range5",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.row.original.range5 === null ? 0 : data.row.original.range5)}</span>;
            },
          },
        ]
        : []),
      ...(active === "MINGGUAN"
        ? [
          {
            id: "M-0",
            Header: () => {
              let a = Math.ceil(moment.utc().local().date() / 7);
              return (
                <span className="me-3">
                  M-{a} {moment.utc().local().format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range1",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-1",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(1, "weeks").date() / 7);
              return (
                <span className="me-3">
                  M-{a} {moment.utc().local().add(1, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range2",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-2",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(2, "weeks").date() / 7);
              return (
                <span className="me-3">
                  M-{a} {moment.utc().local().add(2, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range3",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-3",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(3, "weeks").date() / 7);
              return (
                <span className="me-3">
                  M-{a} {moment.utc().local().add(3, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range4",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-4",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(4, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(4, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range5",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-5",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(5, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(5, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range6",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-6",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(6, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(6, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range7",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-7",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(7, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(7, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range8",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-8",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(8, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(8, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range9",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-9",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(9, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(9, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range10",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-10",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(10, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(10, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range11",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-11",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(11, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(11, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range12",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-12",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(12, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(12, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range13",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-13",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(13, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(13, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range14",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
          {
            id: "M-14",
            Header: () => {
              let a = Math.ceil(moment.utc().local().add(14, "weeks").date() / 7);
              return (
                <span className="me-4">
                  M-{a} {moment.utc().local().add(14, "weeks").format("MMM YYYY")}
                </span>
              );
            },
            accessor: "range15",
            filterable: true,
            Cell: (data) => {
              return <span className="fw-semibold">{currencyFormat(data.value === null ? 0 : data.value)}</span>;
            },
          },
        ]
        : []),
    ],
    [purchaseList, userRole, userType, isCheckAll],
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = purchaseList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPurchaseList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => purchaseList, [purchaseList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Keterangan", "UmurHutang", "UangMuka"],
        pageIndex: pageIdx,
        pageSize: 500,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);

    setPayable(rows.reduce((a, v) => (a = a + parseFloat(v.original.total || 0)), 0));
    setPayable30(rows.reduce((a, v) => (a = a + parseFloat(v.original.range1 || 0)), 0));
    setPayable60(rows.reduce((a, v) => (a = a + parseFloat(v.original.range2 || 0)), 0));
    setPayable90(rows.reduce((a, v) => (a = a + parseFloat(v.original.range3 || 0)), 0));
    setPayable135(rows.reduce((a, v) => (a = a + parseFloat(v.original.range4 || 0)), 0));
    setPayable150(rows.reduce((a, v) => (a = a + parseFloat(v.original.range5 || 0)), 0));
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    var status = statusPurchase.value ? statusPurchase.value : "";
    if (filterDate) {
      let datearr = filterDate?.split(" to ");
      if (datearr) {
        startat = datearr[0];
        endat = datearr[1] ? datearr[1] : datearr[0];
        const param = {
          title: searchValue,
          startat: startat,
          endat: endat,
          status: status,
          departmentId: searchDepartment?.value ?? "",
          branchId: branchSelected?.value ?? "",
          companyId: companySelected?.value ?? "",
          typeId: 1,
          payable: true,
        };
        dispatch(onGetPurchases(param));
        dispatch(onGetCivilContracts(param));
        dispatch(getAccReleaseTrans(param));
        dispatch(getAccTrans(param));
      } else {
        const param = {
          title: searchValue,
          status: status,
          date: "all",
          departmentId: searchDepartment?.value ?? "",
          branchId: branchSelected?.value ?? "",
          companyId: companySelected?.value ?? "",
          typeId: 1,
          payable: true,
        };
        dispatch(onGetPurchases(param));
        dispatch(onGetCivilContracts(param));
        dispatch(getAccReleaseTrans(param));
        dispatch(getAccTrans(param));
      }
    } else {
      const param = {
        title: searchValue,
        status: status,
        date: "all",
        departmentId: searchDepartment?.value ?? "",
        branchId: branchSelected?.value ?? "",
        companyId: companySelected?.value ?? "",
        typeId: 1,
        payable: true,
      };
      dispatch(onGetCivilContracts(param));
      dispatch(onGetPurchases(param));
      dispatch(getAccReleaseTrans(param));
      dispatch(getAccTrans(param));
    }
  }

  function handleResetFilter() {
    setSearchBudget("");
    setFilterDate(null);
    setStatusPurchase([]);
    setSearchDepartment("");
    setSearchValue("");
    setInfo({});
    handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
  }

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      company: companySelected,
      client: clientSelected,
      branch: branchSelected,
      transactionat: moment().format("YYYY/MM/DD"),
      departmentId: "",
      description: "",
      paymentMethod: "",
      type: "CASH OUT",
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Silahkan isi Jumlah Transaksi"),
      company: Yup.object().required("Please Select company").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      branch: Yup.object().required("Silahkan isi Proyek / Cabang").nullable(true),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      dispatch(getAccTransLoading());
      dispatch(getAccReleaseTransLoading());
      if ((expense || []).filter((item) => item.isChecked).length) {
        let addSubmit = {
          statusId: 1,
          userId: null,
          type: values.type,
          transactionat: values.transactionat,
          paymentMethodId: null,
          description: values.description,
          clientId: values.client.value,
          budgetId: null,
          approval: true,
          tagId: null,
          companyId: values.company.value,
          departmentId: (expense || []).filter((item) => item.isChecked).length && (expense || []).filter((item) => item.isChecked)[0].departmentId,
          branchId: values.branch.value,
          salesId: null,
          purchaseId: null,
          legalId: null,
          civilContractId: null,
          civilAccountId: null,
          civilBudgetId: null,
          civilBudgetDetailId: null,
          amount: values.amount,
          at_detail: JSON.stringify([]),
          at_rls: JSON.stringify((expense || []).filter((item) => item.isChecked)),
        };
        dispatch(onAddNewAccTrans(addSubmit));
      }
      validationAccPayment.resetForm();
      setModalAccPayment(false);
      setModalDetail(false);
      //handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
    },
  });

  useEffect(() => {
    if (isAccTransCreated) {
      window.location.reload();
    }
  }, [isAccTransCreated]);

  useEffect(() => {
    if (branchSelected && companySelected) {
      setInfo({});
      handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  document.title = "Hutang | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={purchaseList} />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Hutang" loading={loading || civilContractLoading || accTransloading || vendorLoading || accReleaseTransLoading}>
          <div className="flex-shrink-0">
            <ExportDoc data={printDoc} />
            {/* <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>  */}
            {/* <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xl={2} md={4}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1"> TOTAL</p>
                    <h4 className=" mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={payable} decimals={0} duration={2} />
                    </h4>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={2} md={4}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1"> 1-30 Hari</p>
                    <h4 className=" mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={payable30} decimals={0} duration={2} />
                    </h4>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={2} md={4}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1"> 30-60 Hari</p>
                    <h4 className=" mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={payable60} decimals={0} duration={2} />
                    </h4>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={2} md={4}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1"> 60-90 Hari</p>
                    <h4 className=" mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={payable90} decimals={0} duration={2} />
                    </h4>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={2} md={4}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1"> 90-135 Hari</p>
                    <h4 className=" mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={payable135} decimals={0} duration={2} />
                    </h4>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={2} md={4}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1"> &gt; 135 Hari</p>
                    <h4 className=" mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={payable150} decimals={0} duration={2} />
                    </h4>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xxl={12}>
            <Card>
              {/* {JSON.stringify(logList).replace("[", "").replace("]", "")} */}
              <CardBody className="pt-1">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("1", "TERMIN", searchBudget?.value, searchVendor?.label, searchDepartment?.value);
                      }}
                      href="#"
                    >
                      <i className="ri-bank-card-2-line me-1 align-bottom fs-14"></i> TERMIN JATUH TEMPO
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("2", "MINGGUAN", searchBudget?.value, searchVendor?.label, searchDepartment?.value);
                      }}
                      href="#"
                    >
                      <i className="ri-calendar-event-line me-1 align-bottom fs-14"></i> AGENDA MINGGUAN
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("3", "SUMMARY", searchBudget?.value, searchVendor?.label, searchDepartment?.value);
                        setActiveBlock("");
                      }}
                      href="#">
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> REKAP MATERIAL ALL SUPPLIER
                    </NavLink>
                  </NavItem>
                </Nav>
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <Select
                            isClearable
                            isDisabled={loading || civilContractLoading || accTransloading || vendorLoading || accReleaseTransLoading}
                            name="searchVendor"
                            value={searchVendor}
                            placeholder="Filter Supplier"
                            onChange={(e) => {
                              setSearchVendor(e);
                              toggleTab(activeTab, active, searchBudget?.value, e?.label, searchDepartment?.value);
                            }}
                            options={vendorList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="searchBranch"
                            value={searchBudget}
                            placeholder="Filter Anggaran"
                            isClearable
                            isDisabled={loading || civilContractLoading || accTransloading || vendorLoading || accReleaseTransLoading}
                            onChange={(e) => {
                              setSearchBudget(e);
                              toggleTab(activeTab, active, e?.value, searchVendor?.label, searchDepartment?.value);
                            }}
                            options={civilBudgetTypeList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="searchDepartment"
                            value={searchDepartment}
                            isDisabled={loading || civilContractLoading || accTransloading || vendorLoading || accReleaseTransLoading}
                            isClearable
                            placeholder="Filter Department"
                            onChange={(e) => {
                              setSearchDepartment(e);
                              toggleTab(activeTab, active, searchBudget?.value, searchVendor?.label, e?.value);
                            }}
                            options={departmentList}
                          ></Select>
                        </Col>
                        {/* <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col> */}
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}>
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}>
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  {loading || civilContractLoading || accTransloading || vendorLoading || accReleaseTransLoading || isLoading ?
                    <div className="text-center py-4 text-muted">
                      <p>Memuat data...</p>
                    </div>
                    :
                    activeTab !== "3" ?
                      <div>
                        <div
                          className="table-responsive table-card table-container-sticky mb-1 table-scroll"
                          ref={scrollRef}
                          onMouseDown={handleMouseDown}
                          onMouseLeave={handleMouseLeave}
                          onMouseUp={handleMouseUp}
                          onMouseMove={handleMouseMove}
                          // style={{ cursor: isDown ? "grabbing" : "grab", userSelect: isDown ? "none" : "auto" }}
                          style={{
                            overflow: "auto",
                            maxHeight: "calc(100vh - 340px)",
                            cursor: isDown ? "grabbing" : "grab",
                            //userSelect: isDown ? "none" : "auto",
                          }}
                        >
                          <Table hover {...getTableProps()} className="align-middle table-nowrap table-fixed-header">
                            <thead>
                              {headerGroups.map((headerGroup, index) => (
                                <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                                  {headerGroup.headers.map((column, index) => (
                                    <th key={index} {...column.getSortByToggleProps()}>
                                      {column.render("Header")}
                                      {generateSortingIndicator(column)}
                                      {/* <Filter column={column} /> */}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              <tr className="bg-light">
                                <th></th>
                                <th colSpan={2}>
                                  Total <em className="fs-11 text-muted fw-normal">Hutang SPK yg belum naik inv tidak ditotalkan</em>
                                </th>
                                <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + (v.original.type !== "SPK" && parseFloat(v.original.invoice_non_amount || 0))), 0))}</th>
                                <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.original.invoice_amount || 0)), 0))}</th>
                                <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.original.total_amount || 0)), 0))}</th>
                                <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.original.paid_amount || 0)), 0))}</th>
                                <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.original.total || 0)), 0))}</th>
                                {active === "TERMIN" ? <th colSpan={6}></th> : <th colSpan={13}></th>}
                              </tr>
                              {page.map((row) => {
                                prepareRow(row);
                                return (
                                  <Fragment key={row.getRowProps().key}>
                                    <tr>
                                      {row.cells.map((cell, index) => {
                                        return (
                                          <td {...cell.getCellProps()} key={index}>
                                            {cell.render("Cell")}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </Fragment>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                        <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                          <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                          <Col className="col-md-auto">
                            <div className="d-flex gap-1">
                              <Button
                                className="btn btn-light"
                                onClick={() => {
                                  setPageIdx(pageIndex - 1);
                                  previousPage();
                                }}
                                disabled={!canPreviousPage}
                              >
                                {"<"}
                              </Button>
                            </div>
                          </Col>
                          <Col className="col-md-auto d-none d-md-block">
                            Halaman {pageIndex + 1} dari {pageOptions.length}
                          </Col>
                          <Col className="col-md-auto">
                            <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                          </Col>
                          <Col className="col-md-auto">
                            <div className="d-flex gap-1">
                              <Button
                                className="btn btn-light"
                                onClick={() => {
                                  setPageIdx(pageIndex + 1);
                                  nextPage();
                                }}
                                disabled={!canNextPage}
                              >
                                {">"}
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      :
                      <div>
                        {(summaryList || [])
                          .map((data, key) => {
                            return (
                              <div key={key} className="mb-3">
                                <h4 className="text-left">{data.supplier}</h4>
                                <div className="d-flex flex-wrap align-items-center mb-2">
                                  <div className="block-badge-cell gap-2">
                                    {(data.detail || []).map((b, index) => (
                                      <Badge
                                        key={index}
                                        className={classnames("badge fw-normal fs-12 d-flex align-items-center justify-content-center px-3 py-2", activeBlock === "" || (activeBlock?.name === (b.rab ?? "NON RAB") && activeBlock?.supplier === data.supplier) ? "bg-info text-white fw-semibold" : "bg-soft-info text-dark")}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setActiveBlock({ supplier: data.supplier, name: b.rab ?? "NON RAB" });
                                        }}
                                      >
                                        {b.rab ?? "NON RAB"}
                                      </Badge>
                                    ))}
                                  </div>
                                </div>

                                {(data.detail || [])
                                  .map((d, idx) => {
                                    return <div className={activeBlock === "" || (activeBlock?.name === (d.rab ?? "NON RAB") && activeBlock?.supplier === data.supplier) ? "" : "d-none"} key={idx}>
                                      <Table className="table-border text-center table-hover table-fixed-header mb-3">
                                        <thead className="align-middle">
                                          <tr className="table-active">
                                            <th className="text-start" style={{ width: "32%" }}>
                                              MATERIAL
                                            </th>
                                            <th className="text-start" style={{ width: "18%" }}>
                                              ANGGARAN
                                            </th>
                                            <th className="text-center" style={{ width: "8%" }}>
                                              TOTAL VOLUME
                                            </th>
                                            <th className="text-center" style={{ width: "14%" }}>
                                              TOTAL HARGA
                                            </th>
                                            <th className="text-center" style={{ width: "14%" }}>
                                              TERBAYAR
                                            </th>
                                            <th className="text-right" style={{ width: "14%" }}>
                                              SISA
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody id="newlink">
                                          <tr>
                                            <td colSpan={2} className="text-start text-info fs-14 fw-semibold">
                                              TOTAL
                                            </td>
                                            <td className="text-info fs-14 fw-semibold">
                                              {currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.quantity || 0)), 0))}
                                            </td>
                                            <td className="text-info fs-14 fw-semibold">
                                              {currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.amount_total || 0)), 0))}
                                            </td>
                                            <td className={(d.data || []).reduce((a, v) => (a = a + (parseFloat(v.amount_total || 0) - parseFloat(v.paid || 0))), 0) > 0 ? "text-success fs-14 fw-semibold" : "fs-14 fw-semibold"}>
                                              {currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.paid || 0)), 0))}
                                            </td>
                                            <td className={(d.data || []).reduce((a, v) => (a = a + (parseFloat(v.amount_total || 0) - parseFloat(v.paid || 0))), 0) > 0 ? "text-danger fs-14 fw-semibold" : "fs-14 fw-semibold"}>
                                              {currencyFormat((d.data || []).reduce((a, v) => (a = a + (parseFloat(v.amount_total || 0) - parseFloat(v.paid || 0))), 0))}
                                            </td>
                                          </tr>
                                          {(d.data || [])
                                            .map((o, i) => {
                                              return (
                                                // className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 3 ? "bg-soft-danger" : ""}
                                                <tr key={i}>
                                                  <td className="text-start fw-semibold" style={{ verticalAlign: "middle" }}>
                                                    {o.name}
                                                  </td>
                                                  <td className="text-start" style={{ verticalAlign: "middle" }}>
                                                    {o?.purchase_cvl?.name}
                                                  </td>
                                                  <td className="text-center" style={{ verticalAlign: "middle" }}>
                                                    {currencyFormat(parseFloat(o.quantity ?? 0))}
                                                  </td>
                                                  <td className="text-center" style={{ verticalAlign: "middle" }}>
                                                    {currencyFormat(parseFloat(o.amount_total ?? 0))}
                                                  </td>
                                                  <td className={parseFloat(o.paid ?? 0) > 0 ? "text-center text-success" : "text-center"} style={{ verticalAlign: "middle" }}>
                                                    {currencyFormat(parseFloat(o.paid ?? 0))}
                                                  </td>
                                                  <td className={(parseFloat(o.amount_total ?? 0) - parseFloat(o.paid ?? 0)) > 0 ? "text-danger text-center fs-13" : "text-center fs-13"} style={{ verticalAlign: "middle" }}>
                                                    {currencyFormat(parseFloat(o.amount_total ?? 0) - parseFloat(o.paid ?? 0))}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </tbody>
                                      </Table>
                                    </div>

                                  })}
                              </div>
                            )
                          })}

                      </div>

                  }


                </div>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    DETAIL TRANSAKSI {label}
                  </ModalHeader>
                  <ModalBody>
                    <CardBody className="pb-3">
                      <div className="d-flex align-items-center mb-3">
                        <Nav className="nav-tabs nav-tabs-custom nav-success me-2" role="tablist">
                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeDetailTab === "1" }, "fw-semibold")}
                              onClick={() => {
                                toggleDetailTab("1");
                              }}
                              href="#"
                            >
                              <i className="ri-time-line me-1 align-bottom fs-14"></i> MENUNGGU BAYAR
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeDetailTab === "2" }, "fw-semibold")}
                              onClick={() => {
                                toggleDetailTab("2");
                              }}
                              href="#"
                            >TERBAYAR
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeDetailTab === "3" }, "fw-semibold")}
                              onClick={() => {
                                toggleDetailTab("3");
                              }}
                              href="#"
                            >SEMUA
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <div className="flex-grow-1">
                          <input className="search-box form-control" style={{ maxWidth: "320px" }} placeholder="Filter Data..." onChange={(e) => setQuery(e.target.value)} />
                        </div>
                        <div className="flex-shrink-0">
                          {expense.filter((item) => item.isChecked).length > 0 && (
                            <button
                              className={(userType === "admin" || userType === "client" || (userRole && userRole.split(",").indexOf("createAccTransaction") !== -1)) && (searchBudget?.label || civilBudgetList.length === 0 || (expense || []).filter((item) => item.isChecked)[0]?.type === "Keuangan") ? "btn me-2 btn-info" : "d-none"}
                              onClick={() => {
                                const data = (expense || []).filter((item) => item.isChecked && item.transaction_no && item.transaction_no !== "");
                                validationAccPayment.setFieldValue(
                                  "amount",
                                  data.reduce((a, v) => (a = a + parseFloat(v.total_apply || 0)), 0),
                                );
                                if (data[0]?.type === "Keuangan") {
                                  validationAccPayment.setFieldValue("description", `${data[0].branch} // PEMBAYARAN TAGIHAN ${data[0]?.supplier} // ${data[0]?.description} // No. Rek`);
                                } else {
                                  validationAccPayment.setFieldValue("description", `${searchBudget?.label ?? ""} ${data[0].branch} // PEMBAYARAN TAGIHAN ${(data[0]?.type ?? "").toUpperCase()} ${data[0]?.supplier} // No. Rek`);
                                }
                                toggleAccPayment();
                              }}>
                              REQUEST PEMBAYARAN <span className="fw-semibold fs-14">Rp. {currencyFormat((expense || []).filter((item) => item.isChecked && item.transaction_no && item.transaction_no !== "").reduce((a, v) => (a = a + parseFloat(v.total_apply || 0)), 0))}</span>
                            </button>
                          )}
                          {(expense || []).filter((item) => item.isChecked)[0]?.type === "Keuangan" || civilBudgetList.length === 0 ? "" : searchBudget?.label ? "" : <span className="text-danger me-2 ms-2">FILTER RAB UNTUK PENGAJUAN DANA (JIKA TEKNIK)</span>}
                          <ExportDoc data={printMaterialDoc} />
                        </div>
                      </div>
                      <div>
                        <SimpleBar style={{ height: "520px" }}>
                          <Table className="table-border text-center table-nowrap align-middle mb-0" style={{ position: "relative" }}>
                            <thead className="align-middle" style={{ position: "sticky", top: "0px", zIndex: "1", backgroundColor: "#FFFFFF" }}>
                              <tr className="bg-soft-info">
                                <td style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={activeDetailTab === "1" ? expense.filter(f => f.total > 0).every((item) => item.isChecked) : activeDetailTab === "2" ? expense.filter(f => f.total <= 0).every((item) => item.isChecked) : expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = activeDetailTab === "1" ? expense.filter(f => f.total > 0).every((item) => item.isChecked) : activeDetailTab === "2" ? expense.filter(f => f.total <= 0).every((item) => item.isChecked) : expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => {
                                        if (activeDetailTab === "1" && item.total > 0) {
                                          return {
                                            ...item,
                                            isChecked: !allChecked,
                                            paid_apply: parseFloat(item.total_apply || 0),
                                          };
                                        } else if (activeDetailTab === "2" && item.total <= 0) {
                                          return {
                                            ...item,
                                            isChecked: !allChecked,
                                            paid_apply: parseFloat(item.total_apply || 0),
                                          };
                                        } else if (activeDetailTab === "3") {
                                          return {
                                            ...item,
                                            isChecked: !allChecked,
                                            paid_apply: parseFloat(item.total_apply || 0),
                                          };
                                        } else {
                                          return item
                                        }
                                      });

                                      setExpense(updatedData);
                                    }}
                                  />
                                </td>
                                <td className="text-start">Kontak / Supplier</td>
                                <td style={{ width: "40px" }}></td>
                                <td className="text-center" style={{ width: "120px" }}>
                                  No Transaksi
                                </td>
                                <td className="text-center" style={{ width: "120px" }}>
                                  No Invoice
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tanggal
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Jatuh Tempo
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Total Transaksi
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Total Tagihan
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Terbayar
                                </td>
                                <td className="text-center" style={{ width: "100px  " }}>
                                  Sisa
                                </td>
                                <td className="text-center">Keterangan</td>
                              </tr>

                              <tr className="bg-light border-bottom">
                                <th></th>
                                <th className="text-start text-info" colSpan={6}>
                                  TOTAL
                                </th>
                                <th className="text-info">{currencyFormat((expense || [])
                                  .filter((o) => (activeDetailTab === "3" ? true : activeDetailTab === "1" ? o.total > 0 : o.total <= 0))
                                  .filter((el) => {
                                    return (
                                      (el.transaction_reff ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.transaction_no ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.supplier ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.paid_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.description ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el?.purchase_detail || []).some(function (item) {
                                        return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
                                      }) ||
                                      (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.type ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (handleValidDate(el.transactionat) ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.branch ?? "").toLowerCase().includes(query.toLowerCase())
                                    );
                                  })
                                  .reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</th>
                                <th className="text-info">{currencyFormat((expense || [])
                                  .filter((o) => (activeDetailTab === "3" ? true : activeDetailTab === "1" ? o.total > 0 : o.total <= 0))
                                  .filter((el) => {
                                    return (
                                      (el.transaction_reff ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.transaction_no ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.supplier ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.paid_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.description ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el?.purchase_detail || []).some(function (item) {
                                        return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
                                      }) ||
                                      (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.type ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (handleValidDate(el.transactionat) ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.branch ?? "").toLowerCase().includes(query.toLowerCase())
                                    );
                                  })
                                  .reduce((a, v) => (a = a + parseFloat(v.total_amount || 0)), 0))}</th>
                                <th className="text-info">{currencyFormat((expense || [])
                                  .filter((o) => (activeDetailTab === "3" ? true : activeDetailTab === "1" ? o.total > 0 : o.total <= 0))
                                  .filter((el) => {
                                    return (
                                      (el.transaction_reff ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.transaction_no ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.supplier ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.paid_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.description ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el?.purchase_detail || []).some(function (item) {
                                        return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
                                      }) ||
                                      (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.type ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (handleValidDate(el.transactionat) ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.branch ?? "").toLowerCase().includes(query.toLowerCase())
                                    );
                                  })
                                  .reduce((a, v) => (a = a + parseFloat(v.paid_amount || 0)), 0))}</th>
                                <th className={(expense || [])
                                  .filter((o) => (activeDetailTab === "3" ? true : activeDetailTab === "1" ? o.total > 0 : o.total <= 0))
                                  .filter((el) => {
                                    return (
                                      (el.transaction_reff ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.transaction_no ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.supplier ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.paid_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      ((el.total_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.description ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el?.purchase_detail || []).some(function (item) {
                                        return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
                                      }) ||
                                      (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.type ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (handleValidDate(el.transactionat) ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                      (el.branch ?? "").toLowerCase().includes(query.toLowerCase())
                                    );
                                  })
                                  .reduce((a, v) => (a = a + parseFloat(v.total || 0)), 0) !== 0 ? "text-danger" : "text-info"}>
                                  {currencyFormat((expense || [])
                                    .filter((o) => (activeDetailTab === "3" ? true : activeDetailTab === "1" ? o.total > 0 : o.total <= 0))
                                    .filter((el) => {
                                      return (
                                        (el.transaction_reff ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        (el.transaction_no ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        (el.supplier ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        ((el.paid_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        ((el.total ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        ((el.amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        ((el.total_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        (el.description ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        (el?.purchase_detail || []).some(function (item) {
                                          return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
                                        }) ||
                                        (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) ||
                                        (el.type ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        (handleValidDate(el.transactionat) ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                        (el.branch ?? "").toLowerCase().includes(query.toLowerCase())
                                      );
                                    })
                                    .reduce((a, v) => (a = a + parseFloat(v.total || 0)), 0))}</th>
                                <th className="text-info"></th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || [])
                                .filter((o) => (activeDetailTab === "3" ? true : activeDetailTab === "1" ? o.total > 0 : o.total <= 0))
                                .filter((el) => {
                                  return (
                                    (el.transaction_reff ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.transaction_no ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.supplier ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.paid_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.total ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.total_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.description ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el?.purchase_detail || []).some(function (item) {
                                      return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
                                    }) ||
                                    (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.type ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (handleValidDate(el.transactionat) ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.branch ?? "").toLowerCase().includes(query.toLowerCase())
                                  );
                                })
                                .sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat))
                                .map((o, i) => {
                                  return (
                                    <Fragment key={i}>
                                      <tr className="product bg-light">
                                        <td className="product-id">
                                          <input
                                            type="checkbox"
                                            className={"checkboxDetail ms-2 me-2 form-check-input"}
                                            checked={o.isChecked}
                                            onChange={() => {
                                              const updatedData = expense.map((d) => {
                                                if (activeDetailTab === "1" && d.total > 0) {
                                                  return d.id === o.id ? { ...d, isChecked: !d.isChecked, paid_apply: parseFloat(o.total_apply || 0) } : d;
                                                }
                                                else if (activeDetailTab === "2" && d.total <= 0) {
                                                  return d.id === o.id ? { ...d, isChecked: !d.isChecked, paid_apply: parseFloat(o.total_apply || 0) } : d;
                                                }
                                                else if (activeDetailTab === "3") {
                                                  return d.id === o.id ? { ...d, isChecked: !d.isChecked, paid_apply: parseFloat(o.total_apply || 0) } : d;
                                                }
                                                else {
                                                  return d
                                                }
                                              });
                                              setExpense(updatedData);
                                            }}
                                          />{" "}
                                          {i + 1}
                                        </td>
                                        <td className="text-start fw-semibold">{o.supplier}</td>
                                        <td className="text-center fw-semibold">{o.branch}</td>
                                        <td className="text-center">{o.transaction_no}</td>
                                        <td className="text-center">{o.type === "SPK" ? o.transaction_no : o.transaction_reff}</td>
                                        <td className="text-center">{handleValidDate(o.transactionat)}</td>
                                        <td className="text-center">{handleValidDate(o.dueat)}</td>
                                        <td className={o.total_amount > o.amount ? "text-center text-danger fw-semibold" : "text-center text-primary fw-semibold"}>{currencyFormat(parseFloat(o.amount ?? 0))}</td>
                                        <td className={o.total_amount > o.amount ? "text-center text-danger fw-semibold" : "text-center text-primary fw-semibold"}>{currencyFormat(parseFloat(o.total_amount ?? 0))}</td>
                                        <td className={o.paid_amount > 0 ? "text-center text-success fw-semibold" : "text-center"}>{currencyFormat(parseFloat(o.paid_amount ?? 0))}</td>
                                        <td className={o.total !== 0 ? "text-center text-danger fw-semibold" : "text-center fw-semibold"}>{currencyFormat(parseFloat(o.total ?? 0))}</td>
                                        <td className="text-start">{o.description}</td>
                                      </tr>
                                      {o.total_amount > o.amount &&
                                        <tr className="product">
                                          <td className="product-id fs-11"> </td>
                                          <td className="text-start text-danger fs-11" colSpan={6}>
                                            Nilai transaksi lebih besar dari tagihan selisih Rp {currencyFormat(o.total_amount - o.amount)}
                                          </td>
                                          <td className="text-center text-muted fs-11"></td>
                                          <td className="text-center text-muted fs-11"></td>
                                          <td className="text-center text-muted fs-11"></td>
                                          <td className="product-id fs-11"> </td>
                                        </tr>
                                      }
                                      {(o.purchase_detail || []).map((oo, ii) => {
                                        return (
                                          <tr key={ii} className="product">
                                            <td className="product-id fs-11"> </td>
                                            <td className="text-start text-muted fs-11" colSpan={6}>
                                              <span className="badge text-uppercase badge-soft-info">{oo?.purchase_cvl_budget?.type}</span> {oo.cvl_account + " - " + oo.name} ( {currencyFormat(parseFloat(oo.quantity ?? 0))} * Rp. {currencyFormat(parseFloat(oo.amount ?? 0))} )
                                            </td>
                                            <td className="text-center text-muted fs-11">{currencyFormat(parseFloat(oo.amount_total ?? 0))}</td>
                                            <td className="text-center text-muted fs-11"></td>
                                            <td className="text-center text-muted fs-11"></td>
                                            <td className="product-id fs-11"> </td>
                                          </tr>
                                        );
                                      })}
                                      {((o.apply || []).length > 0 || (o.file || []).length > 0) && (
                                        <tr>
                                          <td></td>
                                          <td colSpan={11} className="pe-0">
                                            <Accordion className="p-0 w-100 border-0 lefticon-accordion accordion-primary custom-accordionwithicon">
                                              {(o.apply || []).length > 0 && (
                                                <AccordionItem className="border-0">
                                                  <div
                                                    className={classnames("accordion-button p-0 m-0 ps-4 fs-13", { collapsed: activeAccordion === i ? false : true })}
                                                    onClick={() => {
                                                      toggleActiveAccordion(i);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                  >
                                                    <div className="p-2 text-info fw-semibold" style={{ width: "100%" }}>
                                                      Jumlah yang sudah diajukan Rp. {currencyFormat((o.apply || []).filter((f) => f?.at_rls_trans?.statusId !== 4).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}
                                                    </div>
                                                  </div>
                                                  <Collapse isOpen={activeAccordion === i ? true : false} className="accordion-collapse bg-light border-0">
                                                    <div className="accordion-body p-0 ps-4 pe-0 fw-normal fs-12 text-dark">
                                                      {(o.apply || []).map((oo, ii) => {
                                                        let type;
                                                        switch (oo?.at_rls_trans?.type) {
                                                          case "CASH IN":
                                                            type = <span className="badge text-uppercase badge-soft-success">{oo?.at_rls_trans?.type}</span>;
                                                            break;
                                                          case "RECEIVABLE":
                                                            type = <span className="badge text-uppercase badge-soft-info">{oo?.at_rls_trans?.type}</span>;
                                                            break;
                                                          case "CASH OUT":
                                                            type = <span className="badge text-uppercase badge-soft-warning">{oo?.at_rls_trans?.type}</span>;
                                                            break;
                                                          case "PAYABLE":
                                                            type = <span className="badge text-uppercase badge-soft-danger">{oo?.at_rls_trans?.type}</span>;
                                                            break;
                                                          default:
                                                            type = <span className="badge text-uppercase badge-soft-primary">{oo?.at_rls_trans?.type}</span>;
                                                            break;
                                                        }
                                                        return (
                                                          <div className="px-2 py-2 text-start border-bottom" key={ii}>
                                                            <p className="mb-1">
                                                              Transaksi No. <span className="fw-semibold">{oo?.at_rls_trans?.transaction_no}</span>, Tanggal <span className="fw-semibold">{handleValidDate(oo?.at_rls_trans?.transactionat)}</span>
                                                              <span className="ms-3 me-3 fw-semibold">Rp. {currencyFormat(parseFloat(oo.amount ?? 0))}</span>
                                                              {type}
                                                              {oo?.at_rls_trans?.statusId === 4 && <span className="badge text-uppercase badge-soft-danger">CANCELED</span>}
                                                              {oo?.at_rls_trans?.statusId === 3 && <span className="badge text-uppercase badge-soft-info">RELEASED</span>}
                                                              {oo?.at_rls_trans?.statusId === 2 && <span className="badge text-uppercase badge-soft-success">APPROVED</span>}
                                                              {oo?.at_rls_trans?.statusId === 1 && <span className="badge text-uppercase badge-soft-warning">DRAFT</span>}
                                                            </p>
                                                            <p className="mb-0 text-muted">{oo?.at_rls_trans?.description}</p>
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </Collapse>
                                                </AccordionItem>
                                              )}
                                              {(o.file || []).length > 0 && (
                                                <AccordionItem className="border-0">
                                                  <div
                                                    className={classnames("accordion-button p-0 m-0 ps-4 fs-13", { collapsed: activeAccordion === i + 10000 ? false : true })}
                                                    onClick={() => {
                                                      toggleActiveAccordion(i + 10000);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                  >
                                                    <div className="p-2 text-info fw-semibold" style={{ width: "100%" }}>
                                                      Bukti Transaksi ({(o.file || []).length})
                                                    </div>
                                                  </div>
                                                  <Collapse isOpen={activeAccordion === i + 10000 ? true : false} className="accordion-collapse bg-light border-0">
                                                    <div className="accordion-body p-0 ps-4 pe-0 fw-normal fs-12 text-dark">
                                                      {(o.file || []).map((f, ii) => {
                                                        let type;
                                                        return (
                                                          <div className="px-2 py-2 text-start border-bottom" key={ii}>
                                                            {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                                              <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                                            ) : (
                                                              <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                                <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                                              </Link>
                                                            )}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </Collapse>
                                                </AccordionItem>
                                              )}
                                            </Accordion>
                                          </td>
                                        </tr>
                                      )}
                                      {o.isChecked && (
                                        <tr className={o.total > 0 && (userType === "admin" || userType === "client" || (userRole && userRole.split(",").indexOf("createAccTransaction") !== -1)) ? "" : "d-none"}>
                                          <td className="product-id fs-11"> </td>
                                          <td className="text-start p-2" colSpan={8}>
                                            {o.transaction_no && o.transaction_no !== "" ? "" : <span className="text-danger badge text-uppercase badge-soft-danger mb-2">BELUM NAIK INVOICE</span>}
                                            <CurrencyInput
                                              prefix="Rp. "
                                              style={{ border: "1px solid #ccc", width: "220px" }}
                                              className="form-control fw-semibold"
                                              placeholder="Jumlah Pengajuan"
                                              disabled={o.transaction_no && o.transaction_no !== "" ? false : true}
                                              defaultValue={o.transaction_no && o.transaction_no !== "" ? o.total_apply : 0}
                                              onValueChange={(value, name, values) => {
                                                const updatedData = expense.map((d) => (d.id === o.id ? { ...d, paid_apply: value, total_apply: value } : d));
                                                setExpense(updatedData);
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      )}
                                    </Fragment>
                                  );
                                })}
                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="11" className="p-3 text-center">
                                    Belum ada data
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                      </div>
                    </CardBody>
                  </ModalBody>
                </Modal>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {info?.material_name ?? ""}
                  </ModalHeader>
                  <ModalBody>
                    <CardBody>
                      <div>
                        <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                          <div className="col-sm-10">
                            <Row className="m-0 p-0 ">
                              <div className="fw-semibold  text-start">
                                <input className="search-box w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => setQuery(e.target.value)} />
                              </div>
                            </Row>
                          </div>
                          <div className="col-sm-2 text-end">
                            <ExportDoc data={printDetailDoc} />
                          </div>
                        </Row>
                        <SimpleBar className="table-container-sticky">
                          <Table className="table-border text-center table-hover table-fixed-header">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => ({
                                        ...item,
                                        isChecked: !allChecked,
                                      }));
                                      setExpense(updatedData);
                                    }}
                                  />
                                </th>
                                <th className="text-center" style={{ width: "100px" }}>
                                  No Transaksi
                                </th>
                                <th className="text-center" style={{ width: "80px" }}>
                                  Tanggal
                                </th>
                                <th className="text-center" style={{ width: "80px" }}>
                                  Jenis
                                </th>
                                <th className="text-right" style={{ width: "170px" }}>
                                  Tag
                                </th>
                                <th className="text-right" style={{ width: "170px" }}>
                                  Jumlah
                                </th>
                                <th className="text-center" style={{ width: "200px" }}>
                                  Keterangan
                                </th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || [])
                                .filter((el) => {
                                  return (
                                    (el.transaction_reff ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.transaction_no ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.supplier ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.paid_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.total ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    ((el.total_amount ?? "").toString() ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.description ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el?.purchase_detail || []).some(function (item) {
                                      return (item.name ?? "").toLowerCase().includes(query.toLowerCase()) || (item.cvl_account ?? "").toLowerCase().includes(query.toLowerCase()) || (item?.purchase_cvl_budget?.type ?? "").includes(query.toLowerCase())
                                    }) ||
                                    (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.type ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (handleValidDate(el.transactionat) ?? "").toLowerCase().includes(query.toLowerCase()) ||
                                    (el.branch ?? "").toLowerCase().includes(query.toLowerCase())
                                  );
                                })
                                .sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat))
                                .map((o, i) => {
                                  let type;
                                  switch (o.type) {
                                    case "CASH IN":
                                      type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                                      break;
                                    case "RECEIVABLE":
                                      type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                                      break;
                                    case "CASH OUT":
                                      type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                                      break;
                                    case "PAYABLE":
                                      type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                                      break;
                                    default:
                                      type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                                      break;
                                  }
                                  return (
                                    // className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 3 ? "bg-soft-danger" : ""}
                                    <tr key={i}>
                                      <td style={{ verticalAlign: "middle", width: "30px" }}>
                                        <div className="hstack gap-2 mt-4 mt-sm-0">
                                          <input
                                            type="checkbox"
                                            className="checkboxDetail me-2 form-check-input"
                                            checked={o.isChecked}
                                            onChange={() => {
                                              const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                              setExpense(updatedData);
                                            }}
                                          />
                                        </div>
                                      </td>
                                      {/* {(o.hasPaid || o.paid_amount >= o.amount) && <span className="badge text-uppercase badge-soft-success mb-3">LUNAS</span>} */}
                                      <td className="text-center" style={{ verticalAlign: "middle" }}>
                                        {o.transaction_no}
                                        {o.statusId === 4 && (
                                          <p className="mb-1">
                                            <span className="badge text-uppercase badge-soft-danger">CANCELED</span>
                                          </p>
                                        )}
                                        {o.statusId === 3 && (
                                          <p className="mb-1">
                                            <span className="badge text-uppercase badge-soft-info">RELEASED</span>
                                          </p>
                                        )}
                                        {o.statusId === 2 && (
                                          <p className="mb-1">
                                            <span className="badge text-uppercase badge-soft-success">APPROVED</span>
                                          </p>
                                        )}
                                        {o.statusId === 1 && (
                                          <p className="mb-1">
                                            <span className="badge text-uppercase badge-soft-warning">DRAFT</span>
                                          </p>
                                        )}
                                      </td>
                                      <td className="text-center" style={{ verticalAlign: "middle" }}>
                                        {handleValidDate(o.transactionat)}
                                      </td>
                                      <td className="text-center" style={{ verticalAlign: "middle" }}>
                                        {type}
                                      </td>
                                      <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                        {o?.at_cvl_account?.name || o?.at_legal?.owner || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                                      </td>
                                      <td className="text-center" style={{ verticalAlign: "middle" }}>
                                        {currencyFormat(o.amount)}
                                      </td>
                                      <td className="text-start" style={{ verticalAlign: "middle" }}>
                                        {o.description}
                                      </td>
                                    </tr>
                                  );
                                })}

                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="7" className="p-3 text-center">
                                    Belum ada realisasi
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                        <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                          <div className="col-sm-6 fs-12 text-start">
                            HUTANG:
                            <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                              {currencyFormat(
                                (expense || [])
                                  .filter((el) => el.type === "PAYABLE" && !el.accTransPaymentId && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                                  .map((el) => parseFloat(el.amount || 0))
                                  .reduce((prev, curr) => prev + curr, 0),
                              )}
                            </span>
                          </div>
                          <div className="col-sm-6 fs-12 text-end">
                            PEMBAYARAN KAS / BANK :
                            <span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">
                              {currencyFormat(
                                (expense || [])
                                  .filter((el) => (el.type !== "PAYABLE" || el.accTransPaymentId) && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                                  .map((el) => parseFloat(el.amount || 0))
                                  .reduce((prev, curr) => prev + curr, 0),
                              )}
                            </span>
                          </div>
                        </Row>
                      </div>
                    </CardBody>
                  </ModalBody>
                </Modal>
                <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
                    PENGAJUAN PEMBAYARAN HUTANG
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <Label htmlFor="amount-field" className="form-label">
                        Anda akan melakukan pengajuan dana untuk {expense.length && expense[0].supplier}
                      </Label>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Jumlah Pengajuan
                          </Label>
                          <CurrencyInput
                            disabled={true}
                            id="cash_amount"
                            name="cash_amount"
                            prefix="Rp. "
                            style={{ border: "1px solid #ccc", width: "100%" }}
                            className="form-control-lg fw-semibold"
                            placeholder="Jumlah Pengajuan"
                            defaultValue={(expense || []).filter((item) => item.isChecked).reduce((a, v) => (a = a + parseFloat(v.paid_apply || 0)), 0)}
                            value={(expense || []).filter((item) => item.isChecked).reduce((a, v) => (a = a + parseFloat(v.paid_apply || 0)), 0)}
                            decimalsLimit={2}
                            onFocus={(e) => e.target.select()}
                            onValueChange={(value, name, values) => validationAccPayment.setFieldValue("amount", value)}
                          />
                          {validationAccPayment.touched.amount && validationAccPayment.errors.amount ? <p className="text-danger">{validationAccPayment.errors.amount}</p> : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Agenda Pembayaran
                          </Label>
                          <Flatpickr
                            className="form-control-lg"
                            style={{ border: "1px solid #ccc", width: "100%" }}
                            id="datepicker-publish-input"
                            placeholder="Pilih Tanggal"
                            options={{
                              mode: "single",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              validationAccPayment.setFieldValue("transactionat", dateStr);
                            }}
                            value={validationAccPayment.values.transactionat ?? ""}
                          />
                          {validationAccPayment.touched.transactionat && validationAccPayment.errors.transactionat && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.transactionat}
                            </small>
                          )}
                        </div>
                        <div className="mb-3">
                          <Input type="textarea" className="form-control" id="description" name="description" rows={3} value={validationAccPayment.values.description ?? ""} onBlur={validationAccPayment.handleBlur} onChange={validationAccPayment.handleChange} invalid={validationAccPayment.touched.description && validationAccPayment.errors.description ? true : false} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">SIMPAN PENGAJUAN PEMBAYARAN</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Purchase;
